export enum NotificationType {
    NewAppointment = 1,
    AppointmentCancelled = 2,
    AppointmentCompleted = 3,
    NewStaffJoined = 4,
    PromotionExpiring = 5,
    System = 6,
    NewBusinessCreated = 7,
    NewUserRegistered = 8
}

export interface NotificationDto {
    id: number;
    title: string;
    message?: string;
    /**
     * The API's wire convention is the enum NAME ("NewAppointment",
     * "StaffBookingAssigned", …); older callers compared numbers. Both tolerated.
     */
    type: NotificationType | string;
    isRead: boolean;
    createdAt: string;
    referenceId?: number;
    /**
     * S2 (AB#2205, SG-16) — structured payload (staff booking notifications), an
     * object or its JSON string. The web renders localized text from type + data.
     */
    data?: Record<string, unknown> | string | null;
}

export interface NotificationListResponse {
    notifications: NotificationDto[];
    unreadCount: number;
}

export interface UnreadCountResponse {
    count: number;
}
